import { getDomainForShefUrl } from 'common/RouteUtils';

export const getDomain = () => {
  return getDomainForShefUrl(process.env.NEXT_PUBLIC_FRONT_END_URL);
};
